import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "n-workspace-tabs control-m" }
const _hoisted_2 = {
  class: "tabs-content",
  ref: "content"
}
const _hoisted_3 = ["onMousedown", "onClick", "onContextmenu"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tabs-background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tabs-background-content" })
], -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  stroke: "#595959",
  class: "tabs-close-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M 4 4 L 12 12 M 12 4 L 4 12" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  class: "tabs-after",
  ref: "after"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NIcon = _resolveComponent("NIcon")!
  const _component_NButton = _resolveComponent("NButton")!
  const _directive_scroll_horizontally = _resolveDirective("scroll-horizontally")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedTabList, (tab, i) => {
        return (_openBlock(), _createElementBlock("div", {
          ref_for: true,
          ref: "item",
          class: _normalizeClass(['tabs-item', { active: tab.tab === _ctx.modelValue }, { move: tab.tab !== _ctx.animateTabKey2 }, `tab-${tab.tab}`, tab.class].filter((item) => item)),
          key: 'item-' + i,
          style: _normalizeStyle({ width: _ctx.tabWidth + 'px', left: tab.left + 'px' }),
          onMousedown: (e) => _ctx.handleMouseDown(e, tab, i),
          onClick: (e) => _ctx.handleClick(e, tab, i),
          onContextmenu: (e) => _ctx.handleMenu(e, tab, i)
        }, [
          _hoisted_4,
          _withDirectives(_createElementVNode("div", {
            class: "tabs-close",
            onClick: _withModifiers(($event: any) => (_ctx.handleDelete(i)), ["stop","prevent"]),
            style: _normalizeStyle({ width: _ctx.tabCloseWidth + 'px' })
          }, _hoisted_7, 12, _hoisted_5), [
            [_vShow, _ctx.canShowTabClose(tab)]
          ]),
          _createElementVNode("div", {
            class: "tabs-main",
            title: tab.label
          }, [
            _createVNode(_component_NIcon, {
              name: tab.icon,
              class: "tabs-favicon"
            }, null, 8, ["name"]),
            _createElementVNode("span", {
              class: _normalizeClass(["tabs-label", { 'no-close': !_ctx.canShowTabClose(tab) }]),
              style: _normalizeStyle({ marginRight: _ctx.canShowTabClose(tab) ? _ctx.tabCloseWidth + 'px' : 0 })
            }, _toDisplayString(tab.label), 7)
          ], 8, _hoisted_8)
        ], 46, _hoisted_3))
      }), 128))
    ])), [
      [_directive_scroll_horizontally]
    ]),
    _createElementVNode("span", _hoisted_9, [
      (_ctx.items.length)
        ? (_openBlock(), _createBlock(_component_NButton, {
            key: 0,
            icon: "add",
            type: "text",
            "icon-size": "20",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleLaunchpad')))
          }))
        : (_openBlock(), _createBlock(_component_NButton, {
            key: 1,
            icon: "add",
            type: "secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleLaunchpad')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.newLabel), 1)
            ]),
            _: 1
          }))
    ], 512)
  ]))
}